export class MensajeRespuestaDTO {

    constructor(
        public mensaje: string,

        public estadoMensaje: string,

        public estadoHttpMensaje: any
    ){
    }

}